// extracted by mini-css-extract-plugin
export var modal = "_58-0";